import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {BluetoothDevice} from '../types/PrinterSettings';
import {DriverState} from '../types/common';
import {StorageKeys} from '@buncha/config/storage/type';
import {storage} from '@buncha/config/storage';

const initialState: DriverState = {
  BLEDevice: undefined,
  disablePrinterFlow: false,
};

const reducer = {
  setBLEDevice: function (
    state: DriverState,
    action: PayloadAction<BluetoothDevice | undefined>,
  ) {
    const payload = action.payload;
    storage.setItem(StorageKeys.BLEDevice, JSON.stringify(payload || ''));
    state.BLEDevice = payload;
  },
  setDiablePrinterFlow: function (
    state: DriverState,
    action: PayloadAction<boolean>,
  ) {
    const payload = action.payload;
    state.disablePrinterFlow = payload;
  },
};

function initSlice() {
  const slice = createSlice({
    name: 'DriverState',
    initialState,
    reducers: reducer,
  });
  return slice;
}

export default initSlice();
